import React from 'react';
import SearchBar from './SearchBar';
import ServicesColumn from './ServicesColumn';
import PractitionersColumn from './PractitionersColumn';

export default function MainPanel(props) {
  const {
    // search
    searchWrapperRef,
    searchQuery,
    setSearchQuery,
    searchResults,
    isSearchFocused,
    setIsSearchFocused,
    handleSearchResultClick,
    // shared
    dataLoading,
    categories,
    specialties,
    activeServices,
    activePractitioners,
    defaults,
    playClickSound,
    // selection
    selectedCategory,
    setSelectedCategory,
    selectedService,
    setSelectedService,
    selectedPractitioner,
    setSelectedPractitioner,
    activePracTab,
    setActivePracTab,
    setMainBgColor,
    // services column
    primaryServicesForCategory,
    addonServicesForCategory,
    includeSalesTax,
    setIncludeSalesTax,
    appSalesTaxRate,
    serviceInfoFontSizeLevel,
    increaseFontSize,
    decreaseFontSize,
    getServiceInfoFontSizeClass,
    adminMode,
    handleOpenEditServiceModal,
    // practitioners column
    primaryOfferedServices,
    addonOfferedServices,
    handleEditPractitioner,
    DAYS,
    getShiftStyles,
  } = props;

  return (
    <>
      <SearchBar
        searchWrapperRef={searchWrapperRef}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        searchResults={searchResults}
        isSearchFocused={isSearchFocused}
        setIsSearchFocused={setIsSearchFocused}
        handleSearchResultClick={handleSearchResultClick}
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 bg-white bg-opacity-95 p-10 rounded-2xl shadow-2xl text-black">
        <ServicesColumn
          dataLoading={dataLoading}
          categories={categories}
          activeServices={activeServices}
          activePractitioners={activePractitioners}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          selectedService={selectedService}
          setSelectedService={setSelectedService}
          setSelectedPractitioner={setSelectedPractitioner}
          setActivePracTab={setActivePracTab}
          setMainBgColor={setMainBgColor}
          primaryServicesForCategory={primaryServicesForCategory}
          addonServicesForCategory={addonServicesForCategory}
          includeSalesTax={includeSalesTax}
          setIncludeSalesTax={setIncludeSalesTax}
          appSalesTaxRate={appSalesTaxRate}
          serviceInfoFontSizeLevel={serviceInfoFontSizeLevel}
          increaseFontSize={increaseFontSize}
          decreaseFontSize={decreaseFontSize}
          getServiceInfoFontSizeClass={getServiceInfoFontSizeClass}
          adminMode={adminMode}
          handleOpenEditServiceModal={handleOpenEditServiceModal}
          playClickSound={playClickSound}
          defaults={defaults}
        />

        <PractitionersColumn
          dataLoading={dataLoading}
          activePractitioners={activePractitioners}
          activeServices={activeServices}
          categories={categories}
          specialties={specialties}
          selectedCategory={selectedCategory}
          selectedPractitioner={selectedPractitioner}
          setSelectedPractitioner={setSelectedPractitioner}
          setSelectedCategory={setSelectedCategory}
          setSelectedService={setSelectedService}
          setMainBgColor={setMainBgColor}
          activePracTab={activePracTab}
          setActivePracTab={setActivePracTab}
          primaryOfferedServices={primaryOfferedServices}
          addonOfferedServices={addonOfferedServices}
          adminMode={adminMode}
          handleEditPractitioner={handleEditPractitioner}
          playClickSound={playClickSound}
          defaults={defaults}
          DAYS={DAYS}
          getShiftStyles={getShiftStyles}
        />
      </div>
    </>
  );
}
